import { create } from "zustand";
import { userTypes } from "../types";

interface USER {
  user: userTypes.User;
  authenticate: {
    isAuthenticated: boolean;
    isPhoneVerified: boolean;
    isBusinessVerified?: boolean;
    isPrimium?: boolean;
  };
  setAuthentication: (data: {
    isAuthenticated: boolean;
    isPhoneVerified: boolean;
    isBusinessVerified?: boolean;
    isPrimium?: boolean;
  }) => void;
  flushUserData: () => void;
  updateUser: (data: userTypes.User) => void;
  setUser: (user: userTypes.User) => void;
  defaultUser: userTypes.User;
  setUserToDefault: () => void;
  userOffline: boolean;
  setUserOffline: (offline: boolean) => void;
}

const userStore = create<USER>((set) => ({
  user: userTypes.EMPTY_USER,
  authenticate: {
    isAuthenticated: false,
    isPhoneVerified: false,
    isBusinessVerified: false,
    isPrimium: false,
  },
  defaultUser: userTypes.EMPTY_USER,
  userOffline: false,

  setUserToDefault: () => {
    set({
      user: userTypes.EMPTY_USER,
      authenticate: {
        isAuthenticated: false,
        isPhoneVerified: false,
        isBusinessVerified: false,
        isPrimium: false,
      },
    });
  },

  setAuthentication: (data: {
    isAuthenticated: boolean;
    isPhoneVerified: boolean;
    isBusinessVerified?: boolean;
    isPrimium?: boolean;
  }) =>
    set({
      authenticate: {
        isAuthenticated: data.isAuthenticated,
        isPhoneVerified: data.isPhoneVerified,
        isBusinessVerified: data.isBusinessVerified,
        isPrimium: data.isPrimium,
      },
    }),
  setUser: (user) => {
    set((state) => {
      return {
        ...state,
        user,
      };
    });
  },

  updateUser: (data) => {
    set((state) => {
      return {
        ...state,
        user: {
          ...state.user,
          ...data,
        },
      };
    });
  },

  flushUserData: () => {
    set(() => {
      return {
        user: userTypes.EMPTY_USER,
        isAuthenticated: false,
        isLoading: false,
        error: "",
      };
    });
  },

  setUserOffline: (offline) => {
    set({ userOffline: offline });
  },
}));

export default userStore;
